"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
exports.useStyles = makeStyles_1.default(() => ({
    dialogWrapper: {
        width: 800,
    },
    radioRoot: {
        padding: 2,
    },
    labelLabel: {
        fontSize: 14,
        height: 20,
    },
    labelRoot: {
        height: 25,
        /** to make radio buttons smaller */
        '& svg': {
            height: 15,
            width: 15,
        },
    },
    radioControl: {
        margin: 0,
    },
    buttonLabel: {
        textTransform: 'uppercase',
    },
}));
//# sourceMappingURL=export-dialog-styles.js.map